import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackOpenedTranscript.meta';

export type TrackOpenedTranscriptParams = {
  id: string;
};

export const useTrackOpenedTranscript = () => {
  const { track } = useAnalyticsUtilities();

  const trackOpenedTranscript = useCallback(
    (params: TrackOpenedTranscriptParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackOpenedTranscript };
};
